import range from "lodash/range";

import { QuestionWithHeaderAndFooter } from "../question";

import { QuestionContent } from "../question-content";
import { EmojiQuestionProps } from "../types";
import { EmojiRadioGroup } from "@/storybook-components/emoji-radio/emoji-radio";

export const EmojiQuestion = (props: EmojiQuestionProps) => {
  const {
    gap,
    required,
    invalid,
    labelClassName,
    questionId,
    disabled,
    questionLabel,
    questionLabelType,
    layoutProps,
    accessibilityTextOfRequired,
    questionLabelProps,
    answer,
    contentLayoutProps,
    options = [],
    answerStackSpacing,
    handleChange,
    answerProps,
    footerStackSpacing,
    note,
    maxNote,
    maxLength,
    errorMessage,
    errorMessageProps,
    noteProps,
    reverseOptions = false,
    getEmojiOptionDataTestId
  } = props;

  const headerFooterProps = {
    gap,
    required,
    invalid,
    labelClassName,
    questionId,
    layoutProps,
    questionLabel,
    questionLabelType,
    accessibilityTextOfRequired,
    questionLabelProps,
    footerStackSpacing,
    answerLength: answer?.length,
    note,
    maxLength,
    maxNote,
    errorMessage,
    errorMessageProps,
    noteProps
  };

  const getEmoji = {
    0: "VeryUnHappy",
    1: "UnHappy",
    2: "Neutral",
    3: "Happy",
    4: "VeryHappy"
  };
  const emojiRange = options.length === 3 ? range(1, 4) : range(0, 5);

  // Faces are tied to the stored sequence, so resolve them before reversing.
  const emojiGroup = options.map((option, index) => ({
    type: getEmoji[emojiRange[index]],
    id: option.id,
    note: option.name
  }));
  const orderedEmojiGroup = reverseOptions
    ? [...emojiGroup].reverse()
    : emojiGroup;

  return (
    <QuestionWithHeaderAndFooter {...headerFooterProps}>
      <QuestionContent>
        <EmojiRadioGroup
          id={questionId}
          disabled={disabled}
          handleChange={handleChange}
          value={answer != null ? String(answer) : ""}
          emojiGroup={orderedEmojiGroup}
          labelProps={{ ...answerProps }}
          gap={answerStackSpacing}
          groupLayoutProps={{ ...contentLayoutProps }}
          getEmojiOptionDataTestId={getEmojiOptionDataTestId}
        />
      </QuestionContent>
    </QuestionWithHeaderAndFooter>
  );
};
